export default __webpack_public_path__ + "81c5d93f27f442c6aa7cb452769353af.png";